module.exports = class ClearMaskService {
  static clear(barcode) {
    if (!barcode || typeof barcode !== 'string') {
      return '';
    }

    return barcode.replace(/( |\.|-)/g, '');
  }
};
